import { createClient } from "@supabase/supabase-js";

const url = (import.meta.env.VITE_PUBLIC_SUPABASE_URL || "").replace(/\/$/, "");
const key = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(url, key, {
  auth: {
    flowType: "pkce",
  },
});

// Helper pra INSERT direto via REST API — sem client SDK overhead
export const supabaseRestInsert = async (table: string, body: Record<string, unknown>) => {
  const resp = await fetch(`${url}/rest/v1/${table}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "apikey": key,
      "Authorization": `Bearer ${key}`,
      "Prefer": "return=representation",
    },
    body: JSON.stringify(body),
  });

  if (!resp.ok) {
    const text = await resp.text();
    let msg = text;
    try {
      const j = JSON.parse(text);
      msg = j.message || j.msg || text;
    } catch {
      // mantém msg como texto bruto
    }
    throw new Error(msg);
  }

  return resp.json();
};

// Upload de foto direto pro Supabase Storage (cliente → bucket, sem edge function)
// Retorna a URL pública da imagem. Dispara erro com a mensagem real do Supabase se falhar.
export const uploadPhotoToStorage = async (blob: Blob, filename: string): Promise<string> => {
  const safeName = filename.replace(/[^a-zA-Z0-9._-]/g, "_");
  const path = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}-${safeName}`;

  const { data, error } = await supabase.storage
    .from("member-photos")
    .upload(path, blob, {
      contentType: blob.type || "image/jpeg",
      upsert: false,
    });

  if (error) {
    // Monta mensagem rica: status HTTP + mensagem do Supabase
    const statusPart = (error as Record<string, unknown>).statusCode
      ? `[HTTP ${(error as Record<string, unknown>).statusCode}]`
      : "";
    throw new Error(`${statusPart} ${error.message}`.trim());
  }

  const { data: urlData } = supabase.storage
    .from("member-photos")
    .getPublicUrl(data.path);

  return urlData.publicUrl;
};